export default __webpack_public_path__ + "static/future-car-infographic-9eedb329f88f0391ca07258feebe0153.jpg";